export const useNavBarStore = definePiniaStore('navBar', () => {
    const sectionData = ref({children:[]} as {children:any[]} & any)
    const title = ref('')
    return {
        sectionData,
        title
    }
})